import React from 'react';
import UserContext from "../userContext";
import { useHistory } from "react-router-dom";

import Loader from "../Layout/Components/Loader";
import '../styles/main.scss';

export default function ResetPassword() {
    const [email, setEmail] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const [message, setMessage] = React.useState({ type: '', text: '' });

    const userContext = React.useContext(UserContext);
    const history = useHistory();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage({ type: '', text: '' });
        setLoading(true);

        try {
            await userContext.apiReducer('reset', { email });
            setLoading(false);
            setMessage({
                type: 'success',
                text: 'Email de réinitialisation envoyé ! Vérifiez votre boîte mail.'
            });
            setTimeout(() => history.push('/'), 3000);
        } catch (err) {
            setLoading(false);
            console.error(err);

            let errorText = 'Une erreur est survenue';
            if (err.message === 'Request failed with status code 500') {
                errorText = 'Erreur du serveur. Contactez informatique@mypacome.fr';
            } else if (err.message === 'Request failed with status code 404') {
                errorText = 'Compte inconnu';
            }

            setMessage({ type: 'error', text: errorText });
        }
    };

    return (
        <div className="auth-page">
            {/* Animated Background */}
            <div className="auth-background">
                <div className="auth-orb auth-orb--1" />
                <div className="auth-orb auth-orb--2" />
                <div className="auth-orb auth-orb--3" />
            </div>

            {/* Auth Card */}
            <div className="auth-card">
                {/* Back Link */}
                <button
                    type="button"
                    className="auth-back-link"
                    onClick={() => history.push('/')}
                >
                    <i className="fas fa-arrow-left" />
                    Retour à la connexion
                </button>

                {/* Logo */}
                <div className="auth-logo">
                    <img
                        src="https://i.ibb.co/3CgD7G4/new-Colors-Logo-2.webp"
                        alt="MYPacôme Logo"
                    />
                    <h1 className="auth-brand">MYPacôme</h1>
                    <p className="auth-tagline">Home Manager</p>
                </div>

                {/* Title */}
                <div className="auth-title">
                    <h2>Mot de passe oublié</h2>
                    <p>Entrez votre email pour recevoir un lien de réinitialisation</p>
                </div>

                {/* Message */}
                {message.text && (
                    <div className={`auth-message ${message.type}`}>
                        {message.text}
                    </div>
                )}

                {/* Form */}
                <form className="auth-form" onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label className="form-label" htmlFor="email">
                            Adresse email
                        </label>
                        <input
                            type="email"
                            id="email"
                            className="form-input"
                            placeholder="votre@email.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            autoComplete="email"
                        />
                    </div>

                    <button type="submit" className="auth-btn">
                        Envoyer le lien
                    </button>
                </form>
            </div>

            <Loader show={loading} message="Envoi en cours..." />
        </div>
    );
}
